import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("d2-container", [_c("wlc-breadcrumb"), _c("div", {
    staticClass: "wlc-space-between"
  }, [_c("el-form", {
    attrs: {
      inline: true,
      model: _vm.searchForm,
      size: "small"
    },
    nativeOn: {
      submit: function submit($event) {
        $event.preventDefault();
      }
    }
  }, [_c("el-form-item", {
    staticClass: "wlc-form-phone",
    attrs: {
      label: "手机号"
    }
  }, [_c("el-input", {
    nativeOn: {
      keyup: function keyup($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.phone,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "phone", $$v);
      },
      expression: "searchForm.phone"
    }
  }), _c("el-tooltip", {
    attrs: {
      content: "\u624B\u673A\u53F7\u6A21\u7CCA\u641C\u7D22\uFF1A\u3010".concat(_vm.searchForm.fuzzy == 1 ? "打开" : "关闭", "\u3011"),
      placement: "top"
    }
  }, [_c("el-switch", {
    attrs: {
      "active-value": "1",
      "inactive-value": "0"
    },
    model: {
      value: _vm.searchForm.fuzzy,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "fuzzy", $$v);
      },
      expression: "searchForm.fuzzy"
    }
  })], 1)], 1), _c("el-form-item", {
    attrs: {
      label: "用户名"
    }
  }, [_c("el-input", {
    nativeOn: {
      keyup: function keyup($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.name,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "name", $$v);
      },
      expression: "searchForm.name"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "用户类型"
    }
  }, [_c("el-select", {
    on: {
      change: function change($event) {
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.user_type,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "user_type", $$v);
      },
      expression: "searchForm.user_type"
    }
  }, [_c("el-option", {
    attrs: {
      label: "房东",
      value: "-3"
    }
  }), _c("el-option", {
    attrs: {
      label: "房客",
      value: "-2"
    }
  }), _c("el-option", {
    attrs: {
      label: "游客",
      value: "-1"
    }
  }), _c("el-option", {
    attrs: {
      label: "充值",
      value: "1"
    }
  }), _c("el-option", {
    attrs: {
      label: "季度",
      value: "3"
    }
  })], 1)], 1), _c("el-form-item", {
    attrs: {
      label: "用户状态"
    }
  }, [_c("el-select", {
    on: {
      change: _vm.userStatusChangeFilter
    },
    model: {
      value: _vm.searchForm.isDefriend,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "isDefriend", $$v);
      },
      expression: "searchForm.isDefriend"
    }
  }, [_c("el-option", {
    attrs: {
      label: "全部",
      value: ""
    }
  }), _c("el-option", {
    attrs: {
      label: "正常",
      value: "0"
    }
  }), _c("el-option", {
    attrs: {
      label: "虚拟号",
      value: "7"
    }
  }), _c("el-option", {
    attrs: {
      label: "已实名",
      value: "4"
    }
  }), _c("el-option", {
    attrs: {
      label: "强制实名",
      value: "9"
    }
  }), _c("el-option", {
    attrs: {
      label: "禁言3天",
      value: "5"
    }
  }), _c("el-option", {
    attrs: {
      label: "永久禁言",
      value: "6"
    }
  }), _c("el-option", {
    attrs: {
      label: "已注销",
      value: "8"
    }
  }), _c("el-option", {
    attrs: {
      label: "已拉黑",
      value: "1"
    }
  }), _c("el-option", {
    attrs: {
      label: "无设备ID",
      value: "10"
    }
  })], 1)], 1), _c("el-form-item", {
    attrs: {
      label: "注册时间"
    }
  }, [_c("el-date-picker", {
    staticStyle: {
      width: "250px"
    },
    attrs: {
      type: "daterange",
      "range-separator": "-",
      "start-placeholder": "开始时间",
      "end-placeholder": "结束时间",
      "value-format": "yyyy-MM-dd",
      "picker-options": _vm.pickerOptions
    },
    on: {
      change: _vm.handleDateChange
    },
    model: {
      value: _vm.searchForm.time,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "time", $$v);
      },
      expression: "searchForm.time"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "聊天人数"
    }
  }, [_c("el-select", {
    on: {
      change: function change($event) {
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.imCount,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "imCount", $$v);
      },
      expression: "searchForm.imCount"
    }
  }, [_c("el-option", {
    attrs: {
      label: "10+",
      value: "1"
    }
  }), _c("el-option", {
    attrs: {
      label: "20+",
      value: "2"
    }
  }), _c("el-option", {
    attrs: {
      label: "30+",
      value: "3"
    }
  }), _c("el-option", {
    attrs: {
      label: "40+",
      value: "4"
    }
  }), _c("el-option", {
    attrs: {
      label: "50+",
      value: "5"
    }
  })], 1)], 1), _c("el-form-item", {
    attrs: {
      label: "第三方登录"
    }
  }, [_c("el-select", {
    on: {
      change: function change($event) {
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.thirdLogin,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "thirdLogin", $$v);
      },
      expression: "searchForm.thirdLogin"
    }
  }, [_c("el-option", {
    attrs: {
      label: "Wechat",
      value: "unionid"
    }
  }), _c("el-option", {
    attrs: {
      label: "Facebook",
      value: "fbUnionid"
    }
  }), _c("el-option", {
    attrs: {
      label: "Apple",
      value: "appleUnionid"
    }
  })], 1)], 1), _c("el-form-item", {
    attrs: {
      label: "国家区号"
    }
  }, [_c("el-select", {
    attrs: {
      filterable: "",
      remote: "",
      "remote-method": _vm.getPhoneCodeList,
      loading: _vm.getPhonePrefixLoading
    },
    on: {
      change: _vm.prefixChangeFilter
    },
    model: {
      value: _vm.searchForm.prefix,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "prefix", $$v);
      },
      expression: "searchForm.prefix"
    }
  }, _vm._l(_vm.phonePrefixList, function (item) {
    return _c("el-option", {
      key: item.id,
      attrs: {
        label: item.ch,
        value: item.prefix
      }
    });
  }), 1)], 1), _c("el-form-item", {
    attrs: {
      label: "设备"
    }
  }, [_c("el-select", {
    on: {
      change: function change($event) {
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.device,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "device", $$v);
      },
      expression: "searchForm.device"
    }
  }, [_c("el-option", {
    attrs: {
      label: "全部",
      value: ""
    }
  }), _c("el-option", {
    attrs: {
      label: "IOS",
      value: "iOS"
    }
  }), _c("el-option", {
    attrs: {
      label: "安卓",
      value: "android"
    }
  }), _c("el-option", {
    attrs: {
      label: "小程序",
      value: "miniprogram"
    }
  }), _c("el-option", {
    attrs: {
      label: "Web",
      value: "Web"
    }
  })], 1)], 1), _c("el-form-item", [_c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: function click($event) {
        return _vm.getData("search");
      }
    }
  }, [_vm._v("搜索 ")]), _c("el-button", {
    attrs: {
      type: "warning"
    },
    on: {
      click: function click($event) {
        _vm.searchForm = {};
        _vm.getData("search");
      }
    }
  }, [_vm._v("重置 ")]), _c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: function click($event) {
        return _vm.$router.push("/user/add");
      }
    }
  }, [_vm._v("添加用户 ")]), _c("el-button", {
    attrs: {
      type: "danger"
    },
    on: {
      click: function click($event) {
        return _vm.$router.push("/user/set/password");
      }
    }
  }, [_vm._v("重置密码 ")])], 1)], 1), _c("el-form", {
    attrs: {
      inline: true,
      model: _vm.searchForm
    }
  })], 1), _c("el-table", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.tableLoading,
      expression: "tableLoading"
    }],
    attrs: {
      data: _vm.tableData,
      "row-class-name": _vm.tableRowClassName,
      border: ""
    }
  }, [_c("el-table-column", {
    attrs: {
      label: "姓名",
      width: "140"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var _ref$row = _ref.row,
          userInfo = _ref$row.userInfo,
          deviceRiskInfo = _ref$row.deviceRiskInfo;
        return [_c("wlc-user-pop", {
          attrs: {
            info: userInfo,
            deviceRisk: "",
            deviceRiskInfo: deviceRiskInfo
          },
          on: {
            saveRemark: _vm.saveRemark
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "phone",
      label: "手机",
      width: "140"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.isVirtualNumber ? _c("el-tag", {
          staticClass: "mr8 wlc-important-tag",
          attrs: {
            size: "small",
            type: "danger"
          }
        }, [_vm._v("虚拟号 ")]) : _vm._e(), _c("div", [_vm._v(_vm._s(scope.row.phone_prefix) + " " + _vm._s(scope.row.phone))])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "消息数",
      width: "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("wlc-im-count", {
          attrs: {
            count: scope.row.imCount,
            userId: scope.row.id
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "用户标签",
      width: "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("wlc-user-table-tag", {
          attrs: {
            userId: scope.row.id,
            list: scope.row.userTag
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "remark",
      label: "备注",
      width: "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("wlc-remark-list", {
          attrs: {
            remarkList: scope.row.remarkList,
            remark: scope.row.remark
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "createTime",
      label: "注册时间",
      width: "150"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "用户类型",
      width: "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.user_type == 1 ? _c("el-tag", {
          attrs: {
            size: "mini",
            type: "warning"
          },
          on: {
            click: function click($event) {
              return _vm.goBrandUserList(scope.row);
            }
          }
        }, [_vm._v("充值用户 ")]) : _vm._e(), scope.row.user_type == 3 ? _c("el-tag", {
          attrs: {
            size: "mini",
            type: "warning"
          },
          on: {
            click: function click($event) {
              return _vm.goQuarterUserList(scope.row);
            }
          }
        }, [_vm._v("季度用户 ")]) : _vm._e(), scope.row.user_type == 0 ? _c("div", [scope.row.isRelease == 2 ? _c("el-tag", {
          attrs: {
            size: "mini",
            type: "success"
          },
          on: {
            click: function click($event) {
              return _vm.goHouseList(scope.row);
            }
          }
        }, [_vm._v("房东 ")]) : scope.row.occupation ? _c("el-tag", {
          attrs: {
            size: "mini",
            type: "primary"
          }
        }, [_vm._v("房客 ")]) : _c("el-tag", {
          attrs: {
            size: "mini",
            type: "info"
          }
        }, [_vm._v("游客")])], 1) : _vm._e()];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "版本信息",
      width: "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("wlc-app-version", {
          attrs: {
            info: scope.row.appInfo || {}
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "用户状态",
      width: "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.status == "-1" ? _c("span", [_vm._v("已注销")]) : scope.row.isDefriend == "1" ? _c("span", [_vm._v("已拉黑")]) : scope.row.disable_send_msg_at == -1 ? _c("span", {
          staticClass: "wlc-button-danger"
        }, [_vm._v("永久禁言")]) : scope.row.disable_send_msg_at > +new Date() / 1000 ? _c("span", {
          staticClass: "wlc-button-danger"
        }, [_vm._v("禁言3天")]) : scope.row.noDeviceId == "1" ? _c("span", [_vm._v("无设备ID")]) : _c("span", [_vm._v(" 正常 ")])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "IM版本",
      width: "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.im_company == "rongcloud" ? _c("el-tag", {
          attrs: {
            size: "mini",
            type: "warning"
          },
          on: {
            click: function click($event) {
              return _vm.toggleImVersion(scope.row);
            }
          }
        }, [_vm._v("融云 ")]) : _vm._e(), scope.row.im_company == "tencent" ? _c("el-tag", {
          attrs: {
            size: "mini",
            type: "success"
          },
          on: {
            click: function click($event) {
              return _vm.toggleImVersion(scope.row);
            }
          }
        }, [_vm._v("腾讯 ")]) : _vm._e()];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "mail",
      label: "邮箱",
      width: "100"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "occupation",
      width: "100",
      label: "职业"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "from",
      label: "来自",
      "min-width": "100"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "身份证信息",
      width: "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return scope.row.auth_info ? [_c("el-popover", {
          attrs: {
            placement: "top-start",
            content: scope.row.auth_info.idcard_number,
            trigger: "hover"
          }
        }, [_c("el-link", {
          attrs: {
            slot: "reference",
            type: "primary"
          },
          on: {
            click: function click($event) {
              $event.stopPropagation();
              return _vm.toPage(scope.row.auth_info);
            }
          },
          slot: "reference"
        }, [_vm._v(" " + _vm._s(scope.row.auth_info.idcard_name) + " "), scope.row.auth_info_account.length > 0 ? _c("span", [_vm._v("* " + _vm._s(scope.row.auth_info_account.length))]) : _vm._e()])], 1)] : undefined;
      }
    }], null, true)
  }), _c("el-table-column", {
    attrs: {
      prop: "imLikeCount",
      label: "获赞&评论",
      width: "100"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "gender",
      width: "80",
      label: "性别"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.gender == 1 ? _c("span", [_vm._v("男")]) : scope.row.gender == 2 ? _c("span", [_vm._v("女")]) : _c("span", [_vm._v("男")])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "age",
      width: "80",
      label: "年龄"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "操作",
      width: "180",
      fixed: "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-button", {
          attrs: {
            size: "mini",
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.updateItem(scope.row);
            }
          }
        }, [_vm._v("编辑 ")]), [scope.row.disable_send_msg == 0 ? _c("el-popover", {
          staticStyle: {
            margin: "0 10px"
          },
          attrs: {
            placement: "bottom",
            width: "210"
          },
          model: {
            value: _vm.visible,
            callback: function callback($$v) {
              _vm.visible = $$v;
            },
            expression: "visible"
          }
        }, [_c("div", [_c("el-button", {
          attrs: {
            size: "mini"
          },
          on: {
            click: function click($event) {
              return _vm.setUserDisableSendMsg(scope.row, 3);
            }
          }
        }, [_vm._v("3天 ")]), _c("el-button", {
          attrs: {
            size: "mini",
            type: "danger",
            plain: ""
          },
          on: {
            click: function click($event) {
              return _vm.setUserDisableSendMsg(scope.row, -1);
            }
          }
        }, [_vm._v("永久禁言 ")]), _c("el-button", {
          attrs: {
            size: "mini",
            type: "danger"
          },
          on: {
            click: function click($event) {
              return _vm.setUserDisableSendMsg(scope.row, -1, "fraud");
            }
          }
        }, [_vm._v("诈骗 ")])], 1), _c("el-button", {
          staticClass: "wlc-button-danger",
          attrs: {
            slot: "reference",
            size: "mini",
            type: "text"
          },
          slot: "reference"
        }, [_vm._v("禁言 ")])], 1) : _c("el-button", {
          staticClass: "wlc-button-danger",
          attrs: {
            size: "mini",
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.setUserDisableSendMsg(scope.row, 0);
            }
          }
        }, [_vm._v("解除禁言 ")])], _c("el-button", {
          attrs: {
            size: "mini",
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.setRemarkDialog(scope.row);
            }
          }
        }, [_vm._v(" 备注 ")]), _c("el-button", {
          attrs: {
            size: "mini",
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.goChat(scope.row);
            }
          }
        }, [_vm._v(" 聊天 ")])];
      }
    }])
  })], 1), _c("div", {
    staticClass: "wlc-pagination"
  }, [_c("el-pagination", {
    attrs: {
      layout: "total, prev, pager, next",
      "page-size": _vm.searchForm.ps,
      "current-page": _vm.searchForm.pn,
      total: _vm.total
    },
    on: {
      "current-change": _vm.pageChange
    }
  })], 1), _c("wlc-remark", {
    attrs: {
      visible: _vm.remarkDialogVisible,
      userId: _vm.currentRemarkObj.id,
      remark: _vm.currentRemarkObj.remark
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.remarkDialogVisible = $event;
      },
      getData: _vm.getData
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };